import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageParticles } from '../voyageParticles-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageCrewHurt {
  crewId: number
  byCrewId: number
  newHitpoints: number
  type: EVoyageCrewDamageType
}

export enum EVoyageCrewDamageType {
  Null = 0,
  Heal = 1,
  SmallBullet = 2,
  Fire = 3,
  NoOxygen = 4,
  FoundLikeThat = 5,
  FireExtinguisher = 6,
  Repair = 7,
  Suicide = 8,
  Jettison = 9,
  Teleport = 10,
}
export function getDamageReason(t: EVoyageCrewDamageType) {
  switch (t) {
    case EVoyageCrewDamageType.Null:
      return 'Null'
    case EVoyageCrewDamageType.Heal:
      return 'Healed'
    case EVoyageCrewDamageType.SmallBullet:
      return 'Gunfire wounds'
    case EVoyageCrewDamageType.Fire:
      return 'Combusted'
    case EVoyageCrewDamageType.NoOxygen:
      return 'Asphyxiated'
    case EVoyageCrewDamageType.FoundLikeThat:
      return 'We did not do it'
    case EVoyageCrewDamageType.FireExtinguisher:
      return 'Fire extinguished'
    case EVoyageCrewDamageType.Repair:
      return 'Repaired'
    case EVoyageCrewDamageType.Suicide:
      return 'Suicide'
    case EVoyageCrewDamageType.Jettison:
      return 'Jettison'
    case EVoyageCrewDamageType.Teleport:
      return 'Teleported'
    default:
      return 'Unknown'
  }
}

export const voyageMessageId = EVoyageMessage.CrewHurt

export function write(m: IMessageWriter, d: IMessageCrewHurt) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write32(m, d.byCrewId)
  messageWriter.write16(m, d.newHitpoints)
  messageWriter.write8(m, d.type)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageCrewHurt = {
    crewId: messageWriter.read32(m),
    byCrewId: messageWriter.read32(m),
    newHitpoints: messageWriter.read16(m),
    type: messageWriter.read8(m),
  }

  return d
}

export function test() {
  let ex: IMessageCrewHurt = {
    crewId: 100,
    byCrewId: 123,
    newHitpoints: 55,
    type: EVoyageCrewDamageType.NoOxygen,
  }
  messageWriter.test('crew-hurt', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  voyageCrew.networkHurt(msg)
}

export function sendMessageAndImmediatelyExecute(msg: IMessageCrewHurt) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
